import muistyled from "@emotion/styled";
import { Grid } from "@mui/material";
import { JelloAnimation } from "../../animations/animations";

export const ProjectsMainContainer = muistyled(Grid, {
  name: "ProjectsMainContainer",
})({
  height: "100%",
  width: "100%",
  direction: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#1E2022",
  display: "flex",
  flexWrap: "wrap",
  overflow: "auto",
});

export const ProjectsHeader = muistyled("h1", {
  name: "ProjectsHeader",
})({
  color: "#fff",
  fontSize: "1.5",
  fontWeight: "bold",
  textAlign: "center",
  fontFamily: "Oswald",
  "@media (min-width: 420px)": {
    fontSize: "50px",
  },
});

export const HeaderWrap = muistyled(Grid, {
  name: "HeaderWrap",
})({
  direction: "column",
  justifyContent: "center",
  alignContent: "center",
  marginTop: "20px",
});

export const CardsMainContainer = muistyled(Grid, {
  name: "CardsMainContainer",
})({
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexWrap: "wrap",
  // border: "1px solid #fff",
  height: "100%",
  width: "80%",
  margin: "100px",
});

export const CardsWrapper = muistyled(Grid, {
  name: "CardsWrapper",
})({
  display: "flex",
  flexWrap: "wrap",
});

export const ProjectImg = muistyled(Grid, {
  name: "ProjectImg",
})({
  width: "400px",
  height: "600px",
  borderRadius: "8px",
  margin: "15px",
  transition: "transform 550ms",
  ":hover": {
    transform: "scale(1.05)",
    transition: "all 0.6s ease-in-out ",
    cursor: "pointer",
    opacity: "0.7",
    background: "linear-gradient(to bottom, #7C9473, #353633)",
  },
  "@media (max-width: 625px)": {
    height: "400px",
    width: "400px",
  },
});

export const ProjectsDetailsContainer = muistyled(Grid, {
  name: "ProjectsDetailsContainer",
})({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center",
});
export const DetailsSummaryContainer = muistyled(Grid, {
  name: "DetailsSummaryContainer",
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "#fff",
  fontFamily: "Oswald",
  height: "100px",
  padding: "12px",
  textAlign: "center",
});
export const DetailsHeaderWrap = muistyled("h1", {
  name: "DetailsHeaderWrap",
})({
  display: "flex",
  color: "#fff",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: "bold",
  fontFamily: "Oswald",
  height: "80px",
});

export const ProjectDetailsButton = muistyled(Grid, {
  name: "ProjectDetailsButton",
})({
  display: "flex",
  height: "50px",
  width: "150px",
  borderRadius: "6px",
  backgroundColor: "#7C9473",
  margin: "20px",
  justifyContent: "center",
  alignItems: "center",
  ":hover": {
    animation: `${JelloAnimation} 1s both`,
  },
});
export const IconLink = muistyled(
  "a",
  {}
)({
  color: "#fff",
  width: "50px",
  height: "50px",
  textDecoration: "none",
});
